// API Base URL configuration
export const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://ikappal.shop'
  : 'http://localhost:5001';

export default API_BASE_URL;
